import { QueryFunctionContext, useQuery } from '@tanstack/react-query';
import { axiosLicensingInstance } from 'api/axios/licensing';
import { routes } from 'api/routes';
import { GetInvoices } from './types';

export type GetPlansParams = {
  billableComponent: 'notification';
};

const get = async ({
  queryKey,
}: QueryFunctionContext<[string, string]>): Promise<GetInvoices> => {
  const [, clientId] = queryKey;

  const { data } = await axiosLicensingInstance.get(
    `${routes['client']}/${clientId}/invoices`,
  );

  return data;
};

const useGetInvoices = (clientId: string, enabled: boolean) => {
  return useQuery({
    queryKey: [`${routes['client']}/invoices`, clientId],
    queryFn: get,
    enabled: Boolean(clientId) && enabled,
  });
};

export default useGetInvoices;
